import { ArrowRight, Wallet, RefreshCw, CheckCircle } from 'lucide-react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      icon: Wallet,
      title: 'Choose currency pair',
      description: 'Select the cryptocurrency you want to exchange and the one you want to receive. We support 1000+ coins and tokens.',
      color: '#3b82f6',
    },
    {
      number: '02',
      icon: RefreshCw,
      title: 'Enter wallet address',
      description: 'Provide the wallet address where you want to receive your funds. Double-check to ensure accuracy.',
      color: '#8b5cf6',
    },
    {
      number: '03',
      icon: CheckCircle,
      title: 'Send & receive',
      description: 'Send your funds to the provided deposit address. Your exchanged crypto will arrive in your wallet within minutes.',
      color: '#06b6d4',
    },
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">
            <span className="label-dot" />
            Simple Process
          </span>
          <h2 className="section-title">
            How It <span className="gradient-text">Works</span>
          </h2>
          <p className="section-subtitle">
            Exchange cryptocurrency in three simple steps. No registration, no KYC for most transactions.
          </p>
        </div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-card" style={{ '--step-color': step.color }}>
              <div className="step-number">{step.number}</div>
              <div className="step-icon-wrapper" style={{ background: `linear-gradient(135deg, ${step.color}20, ${step.color}10)` }}>
                <step.icon className="step-icon" style={{ color: step.color }} />
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              
              {index < steps.length - 1 && (
                <div className="step-arrow">
                  <ArrowRight />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="process-note">
          <div className="note-content">
            <span className="note-icon">⚡</span>
            <p>Average exchange time: <strong>2 minutes</strong></p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
